<mat-card appearance="outlined" class="element-card kpi-metric-element mat-elevation-z1">

  <!-- Loaded View -->
  <ng-container *ngIf="isDataSetLoaded$ | async; else loading">
    <mat-card-title class="element-title">
      {{ metricLabel }}
    </mat-card-title>
    <mat-card-content>
      <div class="element-card-content">
        <div class="kpi-metric-element-text">
          <b *ngIf="!hasDynamicLink" class="metric-value">{{ metricValue }}</b>
          <a *ngIf="hasDynamicLink" [href]="getDynamicLinkUrl() | async" class="metric-value metric-value-link">{{ metricValue }}</a>
          <i [ngClass]="[getTrendArrowIconClass(metricTrend), getTrendIconColor(metricTrend)]"></i>
        </div>
        <div *ngIf="subtitleOne" class="subtitle">
          <span class="subtitle-label">{{ subtitleOneLabel }}</span>
          <span class="subtitle-value">{{ subtitleOne }}</span>
        </div>
      </div>
    </mat-card-content>
  </ng-container>

  <!-- Placeholder View -->
  <ng-template #loading>
    <mat-card-title class="element-title">
      <span syncPulse
        style="display: inline-block; height: 24px; width: 150px; background-color: #f0f0f0; border-radius: 4px;">
      </span>
    </mat-card-title>

    <mat-card-content>
      <div class="element-card-content">
        <div class="kpi-metric-element-text">
          <b class="metric-value">
            <span syncPulse
              style="display: inline-block; height: 36px; width: 100px; background-color: #f0f0f0; border-radius: 4px;">
            </span>
          </b>
          <i>
            <span class="icon-placeholder" syncPulse
              style="display: inline-block; width: 20px; height: 20px; background-color: #f0f0f0; border-radius: 50%; margin-left: 10px;">
            </span>
          </i>
        </div>

        <div class="subtitle" style="margin-top: 4px;">
          <span class="subtitle-label">
            <span syncPulse
              style="display: inline-block; height: 16px; width: 70px; background-color: #f0f0f0; border-radius: 4px; margin-right: 4px;">
            </span>
          </span>
          <span class="subtitle-value">
            <span syncPulse
              style="display: inline-block; height: 16px; width: 80px; background-color: #f0f0f0; border-radius: 4px;">
            </span>
          </span>
        </div>
      </div>
    </mat-card-content>
  </ng-template>

</mat-card>
